import { Link } from "react-router-dom";

const termsData = [
  {
    key: 0,
    question: "1. General & definitions",
    answer: (
      <>
        <div>
          1.1. At Desi Fresh, all deliveries and services are based on our
          General Terms and Conditions (GTC). By placing an order, you agree to
          these terms without restrictions. If you're unable or unwilling to
          accept them, our services cannot be provided. For those ordering on
          behalf of an Organization, you must be authorized and have the ability
          to bind the Organization to our TOS. Our GTC are the foundation of our
          business, and we take them seriously. If you have any concerns, our
          team is available to assist you.
        </div>
        <div>
          1.2. We do not accept any General Terms and Conditions or other
          differing conditions from our customers. Even if these conditions are
          referred to in declarations and we do not expressly object to their
          inclusion, they will not be accepted. Our own General Terms and
          Conditions are the only ones applicable to our deliveries and
          services.
        </div>
        <div>
          1.3. The General Terms and Conditions (GTC) applicable to your
          contract will be the version that was valid at the time of the
          contract's conclusion. Our current GTC can be accessed, downloaded,
          and saved at any time on our website at
          https://www.desifresh.co/EN/AGB.
        </div>

        <div>
          {" "}
          <strong>1.2 Online Offer</strong>{" "}
        </div>

        <div>
          As part of the DESI FRESH delivery service , DESI FRESH offers to put
          together a selection of goods made by the customer in the DESI FRESH
          online shop and send it to DESI FRESH and bring it to an address
          specified by the customer. If the customer wishes, he can purchase the
          goods that have been put together and brought to him upon delivery.
          The DESI FRESH delivery service is a service aimed at the end
          consumer. It is expressly not aimed at wholesale customers who want to
          resell the goods in processed or unprocessed form. DESI FRESHreserves
          the right to refuse compilations and deliveries if the customer is a
          wholesale customer, eg if the customer has ordered quantities that are
          unusual for a household.
        </div>

        <div>
          In connection with the delivery of tobacco products , please note that
          tobacco products are also only sold to end users and in normal
          household quantities . By ordering tobacco products, you declare that
          tobacco products are ordered exclusively for private use/consumption .
        </div>

        <div>
          Furthermore, DESI FRESH rejects combinations and deliveries if the
          customer has not yet reached the age of eighteen (18) at the time the
          article selection is submitted online.
        </div>

        <div>
          <strong>
            1.3 Conclusion of the purchase contract and right of refusal with
            the DESI FRESH delivery service
          </strong>
        </div>

        <div>
          The use of the DESI FRESH delivery service does not yet result in a
          purchase contract between the customer and DESI FRESH . The online
          transmission of the article selection by the customer does not
          represent an offer to conclude a purchase contract, but is completely
          non-binding for the customer and does not oblige him to buy the
          selected article. The customer can DESI FRESH inform you at any time
          that you no longer wish to have the selected items delivered. Rather,
          the customer has the option at any time until acceptance of the goods
          upon delivery to refrain from purchasing the assembled goods. A
          purchase contract with the customer is only concluded if the customer
          decides upon delivery that he wants to purchase the goods he has
          selected in whole or in part and if he then pays for the goods. This
          means that the customer can reject the ordered goods without giving
          reasons until they are accepted upon delivery. In this case, the DESI
          FRESH driver takes the delivery service bring them back with you for
          free. A return of non-defective items and/or a related refund of the
          purchase price are excluded after the conclusion of the purchase
          contract. If there are reasons for complaint, the customer can contact
          customer service, which will check the facts. A return in a market or
          with the next delivery is not possible.
        </div>

        <div>
          <strong>
            1.4 The text of the contract is not saved by the DESI FRESH delivery
            service
          </strong>
        </div>

        <div>
          We do not save the contract text of the order, so that this contract
          text can no longer be accessed by the customer after the order has
          been placed on our website. However, we will send the customer the
          content of the accepted order request in a separate email.
        </div>

        <div>
          The customer has the option of downloading and saving these GTC in PDF
          format by clicking on the "Print" button. In order to be able to open
          and read the PDF file created in this way, a program that can open the
          PDF format (such as Adobe Reader) is required.
        </div>

        <div>
          However, the customer is free to print out the relevant page of the
          online shop during the ordering process using the print function of
          the browser or to save it using the save function.
        </div>

        <div>
          <strong>1.5 Observance of legal requirements by DESI FRESH</strong>
        </div>

        <div>
          DESI FRESH offers the goods in compliance with the relevant legal
          requirements. DESI FRESH receives the product-specific information
          from the respective manufacturer or supplier of the goods and provides
          this in the online shop. The customer is therefore obliged to check
          the declarations of the goods offered as part of the DESI FRESH
          delivery service at the time of delivery. The HACCP concept has been
          implemented. Any liability related to DESI FRESH within the meaning of
          Section 7 of the General Terms and Conditions remains unaffected.
        </div>
      </>
    ),
  },
  {
    key: 1,
    question: "2. Registration Requirement",
    answer: (
      <div>
        In order to initiate the delivery as part of the DESI FRESH delivery
        service , the customer must be registered in the DESI FRESH online shop
        and logged in for the relevant online transmission of their item
        selection. The current terms of use for the DESI FRESH customer account
        apply .
      </div>
    ),
  },
  {
    key: 2,
    question: "3. DESI FRESH services",
    answer: (
      <>
        <div>
          <strong>3.1 Assembly and Delivery</strong>
        </div>
        <div>
          DESI FRESH compiles the article selection made by the customer online
          and delivers it to the address specified by the customer (up to the
          front door).
        </div>

        <div>
          <strong>3.2 Delivery times, redelivery</strong>
        </div>
        <div>
          If the delivery is unsuccessful because DESI FRESH cannot find the
          customer or an adult representative/courier at the address specified
          by the customer, DESI FRESH will attempt, if possible and reasonable,
          to contact the customer by telephone or SMS to arrange a new delivery
          date on to be agreed on the same day. If this is not possible,
          reasonable or successful, DESI FRESH will cancel the delivery. If you
          have provided a mobile number, we may use this to inform you via SMS
          about the status of your delivery.
        </div>

        <div>
          <strong>3.3 No delivery abroad</strong>
        </div>
        <div>
          Deliveries only take place on the territory of the Federal Republic of
          Germany.
        </div>

        <div>
          <strong>3.4 Subject to availability; alternative item</strong>
        </div>

        <div>
          DESI FRESH assembles the goods according to the customer's article
          selection, provided that the goods specified by the customer are
          available in the selected DESI FRESH store or warehouse within the
          delivery period. DESI FRESH will suggest alternative items to the
          customer if a product is not in stock or not in sufficient quantity.
        </div>

        <div>
          <strong>3.5 Selection of Bulk Goods</strong>
        </div>

        <div>
          In the case of loose goods (particularly from the areas of fruit,
          vegetables, meat, sausage and cheese), DESI FRESH will endeavor to put
          together the quantity requested by the customer and to keep deviations
          in quantity as small as possible. Loose goods are goods that are
          advertised/offered unpackaged according to weight/volume/length or
          area and are weighed individually for the customer based on the
          quantity specified by the customer, so that the final price to be paid
          by the customer - based on the specified basic price in euros per 100
          ml or 100 g or in euros per 1 kg / 1 L / - 1 m² or 1 m³ refers to the
          actually weighed quantity.
        </div>

        <div>
          <strong>3.6 Selection of Non-Calibrated Goods</strong>
        </div>

        <div>
          In the case of goods that are not calibrated (particularly from the
          fruit, vegetable, meat, sausage and cheese sectors), DESI FRESH will
          endeavor to select packs whose content corresponds as closely as
          possible to the quantity requested by the customer. Non-calibrated
          goods are goods that are advertised/offered packaged according to
          weight/volume/length or area and where each package has a different
          nominal volume, so that the final price to be paid by the customer -
          based on the stated basic price in euros per 100 ml or 100 g or in
          euros per 1 kg / 1 L / 1 m² or 1 m³ - refers to the actual quantity.
        </div>

        <div>
          <strong>3.7 Quantity limitation, normal household quantities</strong>
        </div>

        <div>
          DESI FRESH reserves the right to limit the compilation and delivery of
          certain goods (e.g. certain crates of drinks) to a certain quantity.
          At the latest when a larger quantity is added to the shopping cart,
          the customer receives a notification of the article-specific quantity
          limit. Even if there is no article-specific quantity limit, only
          normal household quantities of the respective goods are taken into
          account when the goods are put together and delivered. This means that
          DESI FRESHreserves the right to shorten the customer's selection of
          articles if the customer has selected quantities that are not usual
          for households. In particular, beverage crate orders with a total of
          more than seven (7) beverage crates are considered to be unusual in
          the household. Unless there is a lower article-specific quantity
          limit, the customer can order a maximum of 7 beverage crates without
          being able to order additional beverage containers. If the normal
          household quantity is exceeded when the order is placed and DESI FRESH
          therefore shortens the customer's selection of items, DESI FRESH will
          inform the customer accordingly.
        </div>

        <div>
          <strong>3.8 Reservation of Delivery Dates</strong>
        </div>
        <div>
          DESI FRESH offers the temporary reservation of specific delivery
          dates. For this purpose, different delivery dates for the reservation
          are determined on the basis of the evaluation of past orders and the
          forecasts for the orders to be expected. The delivery dates offered
          may therefore change over time. There is no entitlement to the
          permanent availability of specific delivery dates.
        </div>
      </>
    ),
  },
  {
    key: 3,
    question:
      "4. Minimum order value; delivery fee; commodity prices; signature service",
    answer: (
      <>
        <div>
          <strong>4.1 Minimum Order Value</strong>
        </div>
        <div>
          A minimum order value (excluding deposit and service fees) applies to
          ordering and delivery, which is shown at the beginning of the ordering
          process. The amount of the minimum order value is determined by the
          zip code of the specified delivery address.
        </div>

        <div>
          <strong>4.2 Delivery Fee; beverage crates</strong>
        </div>
        <div>
          For the provision of the services according to Section 4, DESI FRESH
          generally charges a delivery fee for the use of the DESI FRESH
          delivery service , which is displayed in the delivery window selected
          by the customer. If the customer's order time coincides with a DESI
          FRESH campaign in which DESI FRESH pays the delivery fee, DESI
          FRESHthis to the customer before completing the order. However, the
          delivery fee is only payable if the customer actually buys at least
          one of the items he has selected; payment of the delivery charge will
          then be made as part of the payment for the goods upon delivery. If
          the customer decides not to purchase the items delivered to him, he
          does not have to pay the delivery fee.
        </div>
        <div>
          The delivery fee to be paid (including statutory sales tax) depends on
          the selected delivery window and the shopping cart value. The shopping
          cart value is the sales value of the goods including the statutory
          sales tax (without deposit, beverage surcharge and delivery charges).
          From a shopping cart of €80, the delivery fee is between €2.90 and
          €4.90. From a shopping cart value of €120, the delivery fee is between
          €0 and €1.90. The amount of the respective delivery fee can be found
          in the overview of currently available delivery times at the time the
          delivery window is selected and in the order overview. The delivery of
          beverages may trigger a beverage surcharge. There is no beverage
          surcharge for the first two beverage crates. From the third (3) crate,
          a beverage surcharge of one fifty (1.50) euros per crate will be
          charged, but this is only payable if the customer actually buys the
          goods. Please note the following provisions for the basic calculation
          of beverage surcharges:
        </div>
        <div>
          <strong>Beer / water / soft drinks</strong>
        </div>
        <div>
          1 beverage six-pack container or 6 individual bottles (0.75l, 1l,
          1.25l, 1.5l or 2l) = 1 beverage crate;
        </div>
        <div>
          4 beverage six-pack containers (0.5l or 0.33l) = 1 beverage crate;
        </div>
        <div>
          1 four-pack beverage container or 4 individual bottles (0.75l, 1l,
          1.25l, 1.5l or 2l) = 1 beverage crate;
        </div>
        <div>
          4 drinks four-pack containers (0.5l or 0.33l) = 1 drinks crate;
        </div>
        <div>1 drinks keg (5l) = 1 drinks crate</div>
        <div>
          <strong>milk / juice</strong>
        </div>
        <div>
          12 individual Tetra Packs (0.75l, 1l, 1.5l or 2l) = 1 beverage crate
        </div>
        <div>
          Specific bulky goods points are assigned to the containers, which add
          up to a crate of drinks. This is for purely logistical reasons, as the
          space in our delivery vehicles has to be calculated. If the customer
          now orders goods that are not assigned full bulky goods points, the
          partial quantities are added up by the system and combined into
          logistical units of a beverage crate to be delivered. The beverage
          surcharge to be paid in total will be shown in the shop when the order
          is completed.
        </div>

        <div>
          <strong>
            4.4 Goods Prices; loose goods; Value added tax; order change
          </strong>
        </div>
        <div>
          The prices specified in the DESI FRESH online shop as part of the
          selection process may deviate (up and down) from the prices that are
          valid at the time of compilation and delivery in the selected DESI
          FRESH store. However, the sales prices shown in the online shop at
          www.DESI FRESH.de at the time of the online transmission of the
          article selection or, in the case of loose goods within the meaning of
          Section 4.6, are decisive for the purchase contract, which the
          customer can conclude at the delivery address specified by him The
          stated basic prices in euros per 100 ml or 100 g or the basic prices
          in euros per 1 kg / 1 L / 1 m² or 1 m³. All prices quoted by DESI
          FRESH include the statutory sales tax.
        </div>
        <div>
          The customer has the opportunity to change his order until it is
          processed. This time may vary depending on the workload. A change can
          be made in the DESI FRESH customer account using the "Change order
          now" button. If the order has already been processed, it is no longer
          possible to change the order using the button. If the customer changes
          parts or the entire order, this affects the total price of the order.
          Previous offer prices, even for items not affected by the change, can
          expire, so that the newly triggered order also includes the current
          item prices. Accordingly, the previous payment reservation will be
          deleted and made again after the order change. The customer will be
          informed again about the effects of the order change before pressing
          the "Change order now" button.
        </div>

        <div>
          <strong>4.5 Signature Performance</strong>
        </div>
        <div>
          If the customer decides to purchase the goods upon delivery, he
          confirms with his signature to the supplier that the purchase contract
          has been concluded, the correctness of the delivered goods, the
          deposit values ​​of any empties that have been taken back and any
          coupons/advantage cards that have been redeemed, etc.
        </div>
      </>
    ),
  },
  {
    key: 4,
    question: "5. Method of payment/credit check",
    answer: (
      <>
        <div>
          <strong>5.1 Method of Payment, Billing</strong>
        </div>
        <div>
          The payment for the goods (possibly including a deposit) and the
          delivery fee is made by direct debit, on account, by credit card or
          PayPal after conclusion of the purchase contract upon delivery of the
          goods and settlement of any deposit returns, vouchers, etc.
        </div>
        <ul style={{ paddingLeft: 25 }}>
          <li>
            When paying by direct debitthe debiting takes place within one week
            after delivery of the goods. By choosing to pay by direct debit, you
            give us a SEPA mandate that authorizes us to collect the invoice
            amount from your account. We reserve the right to carry out a credit
            check to hedge the credit risk. Information on data processing as
            part of the credit check can be found in our data protection
            information: https://www.DESI
            FRESH.de/service/datenschutz/lieferservice-abholservice We also
            reserve the right to pass on fees for unauthorized returned direct
            debits. For each returned direct debit, you will be charged the fees
            estimated by the bank for the failed direct debit attempt. Postage
            and shipping costs may be added. However, you are free to provide
            evidence of less damage or no damage at all to DESI FRESH. We
            reserve the right to assert further damages caused by delay.
          </li>
          <li>
            When purchasing on account, the following special features apply in
            addition to the above: The purchase price is due upon delivery and
            handover of the goods to you or a third party named by you. You
            transfer the invoice amount within 14 days after delivery of the
            goods. All necessary information will be sent to your email address
            via email. If you have not received the invoice by e-mail, you can
            get the bank details from customer service on the following
            telephone number +49 (0)221 - 1773 9777 or by e-mail at info@DESI
            FRESH-online.deask. We reserve the right to carry out a credit check
            with SCHUFA Holding AG, Kormoranweg 5, 65201 Wiesbaden (see “Credit
            check” below) to hedge the credit risk. Information on data
            processing as part of the credit check can be found in our data
            protection information:{" "}
            <Link
              to={"/data-protection"}
              style={{ color: "var(--color-primary)" }}
            >
              Here
            </Link>
          </li>
          <li>
            When paying by credit card, we accept American Express (Amex),
            VisaCard and MasterCard. We use the services of Computop GmbH,
            Schwarzenbergstraße 4, 96050 Bamberg as payment service provider.
            The debiting of the purchase price takes place only after delivery
            of the order.
          </li>
          <li>
            When paying by PayPalthe debit is usually made on the same day and
            is processed by PayPal (Europe) S.à rl et Cie, SCA, 22-24 Boulevard
            Royal, L-2449 Luxembourg, registered in the RCS Luxembourg
            commercial register under number B 118 349 . When paying via PayPal,
            you authorize DESI FRESH to collect the payments to be made by you
            from a PayPal account to be named by you when they are due. You have
            to confirm the automatic collection (so-called reference
            transaction) by DESI FRESH at PayPal in order to be able to use the
            service. By confirming the automatic debit, DESI FRESH is entitled
            to debit amounts of different amounts from your PayPal account. The
            amounts vary depending on the quantity of goods purchased. We would
            like to point out that you may incur costs according to PayPal's
            terms of use, if you decide to use PayPal's payment service. The
            costs incurred will be displayed when you select the payment method.
            You can revoke the automatic debit at any time in your DESI FRESH
            customer account. If you want to use Paypal as a payment method
            again in the future, you will be asked again in the customer account
            whether you agree to the merchant debit. If auto-indent is left on,
            no further prompt will appear. whether you agree to the merchant
            debit. If auto-indent is left on, no further prompt will appear.
            whether you agree to the merchant debit. If auto-indent is left on,
            no further prompt will appear.
          </li>
        </ul>

        <div>
          It is not possible to pay part or all of the open invoice amount in a
          DESI FRESH store.
        </div>
        <div>
          The customer receives an e-mail invoice for the items purchased, which
          also lists the empties that have been returned. DESI FRESH reserves
          the right to block the customer's registration and thus access to the
          online shop as a whole if there are defaults or delays in payment or
          if the order itself has been improperly processed several times. To
          protect against credit risk, we reserve the right to restrict the
          choice of payment methods. Refunds are made in the same way as we
          received the payments from the customer.
        </div>

        <div>
          <strong>5.2 Redemption of empties deposit and other vouchers</strong>
        </div>
        <div>
          Empties for which a deposit has been deposited (but not deposit
          receipts) can be handed over to the driver. However, the drivers can
          only transport empties if they are sorted and clean and the deposit
          seal is visible. Please note that drivers are only obliged to accept
          empties that correspond to the DESI FRESH range in terms of type and
          size/volume of the packaging. Another restriction is that empties can
          only be returned in the quantity that was ordered and delivered in the
          current delivery. In addition, the customer always has the option of
          handing in empties subject to a deposit in all DESI FRESH stores and
          redeeming the deposit. The DESI FRESH gift card cannot be redeemed as
          part of the DESI FRESH delivery service.
        </div>
        <div>
          If a DESI FRESH delivery service voucher (discount voucher) is used
          for billing (applies to incentive and campaign vouchers that are
          neither a DESI FRESH gift card nor a payback coupon), then the amount
          is distributed to all discountable items covered by the voucher and
          their sales price reduced in equal parts.
        </div>
        <div>
          If it is a promotional discount, which is usually given in percentage
          points, the promotional discount will be deducted directly from the
          item price. The discount value is displayed directly under the
          respective item on the customer invoice.
        </div>
        <div>
          If it is a discount that is granted in the form of a voucher value
          shown in euros, this voucher value is not shown under the affected
          articles, but as a separate invoice item.
        </div>
        <div>
          To which articles the DESI FRESH delivery service voucher is
          applicable can be found in the conditions of redemption on the
          respective voucher.
        </div>
        <div>
          If you give us back the item discounted via a voucher, the purchase
          price will be refunded after deduction of the amount discounted by the
          voucher. You get back the amount that you actually paid for the item
          after deducting the DESI FRESH delivery service voucher.
        </div>
      </>
    ),
  },
  {
    key: 5,
    question: "6. Privacy",
    answer: (
      <>
        <div>
          We collect, process and use your personal data insofar as this is
          necessary for the establishment, implementation or termination of this
          contract. Any further collection, processing and use of your personal
          data will only take place if this is permitted by law or if you have
          given your consent. You can find more information in our privacy
          policy .
        </div>
      </>
    ),
  },
  {
    key: 6,
    question: "7. Liability",
    answer: (
      <>
        <div>
          <strong>7.1</strong> DESI FRESH shall have unlimited liability for
          damage resulting from injury to life, limb or health resulting from a
          breach of duty by a legal representative or vicarious agent of DESI
          FRESH.
        </div>
        <div>
          <strong>7.2</strong> For other liability claims, DESI FRESH is only
          liable without limitation in the event of intent and gross negligence
          on the part of its legal representatives, managerial employees and
          vicarious agents.
        </div>

        <div>
          <strong>7.3</strong> DESI FRESH is not liable for simple negligence on
          the part of its legal representatives, managerial employees and
          vicarious agents, unless an obligation is breached, the observance of
          which is of particular importance for the achievement of the purpose
          of the contract (cardinal obligation). Cardinal obligations are such
          obligations, the fulfillment of which enables the proper execution of
          the contract, the violation of which jeopardizes the achievement of
          the purpose of the contract and on the observance of which the other
          contracting party regularly relies. In the event of a negligent breach
          of a cardinal obligation, liability is limited to the foreseeable
          damage typical of the contract.
        </div>

        <div>
          <strong>7.4</strong> Further liability under the Product Liability Act
          remains unaffected.
        </div>
      </>
    ),
  },
  {
    key: 7,
    question: "8. Protection of minors",
    answer: (
      <>
        <div>
          <strong>8.1</strong> Articles that are subject to the Youth Protection
          Act (including wine and beer) are only delivered to persons over the
          age of 18. The age must be proven in a suitable manner. By ordering on
          the basis of our general terms and conditions, you declare that you
          are of legal age and have full legal capacity. By submitting the
          order, you assure that you are over 18 years old and that all age,
          name and address information is correct. As a customer, you are
          obliged to ensure that only you or an adult authorized by you can
          accept the delivery of goods. Insofar as persons who are not of legal
          age initiate orders by stating false facts and/or without the consent
          of their adult responsible persons who are authorized to care for them
          or represent them,
        </div>
        <div>
          <strong>8.2</strong> As part of the delivery, an additional age check
          is carried out if there are doubts that the person who receives the
          delivery is of legal age. The ordered goods will not be delivered to
          persons under the age of 18. If the delivery cannot be handed over at
          the front door as a result of the age verification, you have to bear
          the additional costs for returning the order.
        </div>
      </>
    ),
  },
  {
    key: 8,
    question: "9. Integration of PAYBACK into DESI FRESH delivery service",
    answer: (
      <>
        <div>
          <strong>
            9.1 Use of the PAYBACK card and PAYBACK eCoupons/paper coupons as
            well as PAYBACK eVouchers
          </strong>
        </div>
        <div>
          If you are a member of PAYBACK and you have deposited your PAYBACK
          card in your DESI FRESH online account, you have the opportunity to
          collect PAYBACK points with your purchase. At the same time, you can
          redeem e-coupons, paper coupons or e-vouchers during the checkout
          process. You can find more details in the DESI FRESH online shop at
          www.DESI FRESH.de. Here, data is recorded and passed on. We refer to
          our data protection regulations as well as to the more extensive data
          protection regulations of PAYBACK .
        </div>

        <div>
          <strong>Notice to Businesses</strong>
        </div>
        <div>
          We would like to point out that the use of PAYBACK points from
          purchases for your company must be taken into account to reduce
          expenses and input tax.
        </div>

        <div>
          <strong>9.2 Special requirements for using PAYBACK e-vouchers</strong>
        </div>
        <div>
          Only five PAYBACK e-vouchers can be used per purchase. After deducting
          other discounts granted by DESI FRESH, a positive invoice amount must
          remain even after deducting the PAYBACK e-voucher. If the redemption
          of the PAYBACK e-voucher would result in a negative amount, the
          voucher is not deductible. However, the already activated e-voucher
          remains valid and can be used for the next purchase.
        </div>

        <div>
          <strong>
            9.3 Activating and Redeeming Multiple eCoupons or Paper Coupons
          </strong>
        </div>
        <div>
          It is possible to activate up to 5 PAYBACK eCoupons online when
          ordering. Later activation at the front door is not possible. However,
          the customer cannot influence the selection of the eCoupons to be
          redeemed. The combination that best suits the customer is always
          redeemed. If one or more of the items ordered by the customer cannot
          be delivered, the PAYBACK eCoupon or PAYBACK paper coupon will not be
          redeemed. The eCoupon or paper coupon remains valid.
        </div>
        <div>
          If one or more of the items ordered by the customer cannot be
          delivered or if the customer does not collect the ordered goods at the
          front door, the PAYBACK eCoupon or PAYBACK paper coupon will not be
          redeemed. The eCoupon or paper coupon remains valid.
        </div>
        <div>
          PAYBACK eCoupons and PAYBACK paper coupons have a limited period of
          validity, which is stated on the respective coupon. The corresponding
          coupon can only be used if the acceptance of the goods, and thus the
          invoicing, takes place by the specified date of validity. If payment
          is made after the validity date, the coupon cannot be redeemed.
        </div>

        <div>
          <strong>9.4</strong> DESI FRESH vouchers or PAYBACK vouchers or
          PAYBACK eCoupons must be specified online when ordering. It is not
          possible to redeem the vouchers with the driver. It is also not
          possible for the driver to scan the PAYBACK card. You can use the full
          benefits of the PAYBACK card if you store your PAYBACK card in your
          customer profile. If you do not accept individual or all goods at the
          front door, your previously activated PAYBACK vouchers and eCoupons
          will not expire. Only a previously activated voucher for the delivery
          service expires if you do not accept any goods.
        </div>
      </>
    ),
  },
  {
    key: 9,
    question: "10. Use of DESI FRESH coupons via the DESI FRESH app",
    answer: (
      <>
        <div>
          <strong>10.1</strong> If you use the DESI FRESH app when making your
          purchase via the DESI FRESH delivery service, you have the option of
          activating the DESI FRESH coupons displayed in the app and using the
          advantages of the DESI FRESH coupons. The possibility of using the
          DESI FRESH coupons is not related to participation in the Payback
          program.
        </div>
        <div>
          <strong>10.2</strong> Further information on using the DESI FRESH
          coupons can be found here or when you open the DESI FRESH app under
          “DESI FRESH Coupons – How do coupons work at DESI FRESH” and in the
          instructions for redeeming the respective coupon.
        </div>
      </>
    ),
  },
  {
    key: 10,
    question: "11. Governing Law; place of jurisdiction",
    answer: (
      <>
        <div>
          <strong>11.1 Applicability of German law</strong>
        </div>

        <div>
          German law applies exclusively to all disputes that arise in
          connection with the initiation, execution or processing of the{" "}
          <strong>
            DESI FRESH delivery service , unless mandatory consumer protection
            regulations of the country in which you have your habitual residence
            have priority.
          </strong>
        </div>
        <div>The application of the UN sales law is excluded.</div>

        <div>
          <strong>11.2 Venue Agreement</strong>
        </div>
        <div>
          If the contractual partner is a merchant, a legal entity under public
          law or a special fund under public law, our place of business
          (Cologne) is agreed as the exclusive place of jurisdiction for all
          claims arising from or on the basis of this contract. The same applies
          to persons to be sued in legal proceedings who do not have a general
          place of jurisdiction in Germany or to persons to be sued in legal
          proceedings who have moved their domicile or habitual place of
          residence outside of Germany after conclusion of the contract or whose
          domicile or habitual place of residence is in Germany The time when
          the lawsuit was filed is not known. The statutory place of
          jurisdiction for dunning proceedings is excluded from this agreement
          on place of jurisdiction.
        </div>
      </>
    ),
  },
  {
    key: 11,
    question: "12. Severability Clause",
    answer: (
      <div>
        Should individual provisions of these GTC be wholly or partially
        ineffective, the rest of the GTC shall remain effective.
      </div>
    ),
  },
  {
    key: 12,
    question: "13. Consumer Arbitration",
    answer: (
      <div>
        We hereby inform you that DESI FRESH does not participate in dispute
        settlement procedures of a consumer arbitration board within the meaning
        of the Consumer Dispute Settlement Act and is not obliged to do so.
      </div>
    ),
  },
];

export { termsData };
